/**
 * @ngdoc service
 * @name common.store.service:ItxStoreLocatorSvc
 * @description
 * Store Locator service. Encapsulates heavy logic of the store locator.
 */
(function() {

    'use strict';

    angular.module('itxApp.common')
        .factory('ItxStoreLocatorSvc', ItxStoreLocatorSvc);

    ItxStoreLocatorSvc.$inject = ['$q','ItxConfigurationSvc','ItxTranslateSvc'];
    
    function ItxStoreLocatorSvc($q,ItxConfigurationSvc,ItxTranslateSvc) {

        var _this = this;

        var service = {
            step: 'list',
            setStep: _setStep,
            getStep: _getStep,
            setSearchType: _setSearchType,
            getTimeTable: _getTimeTable,
            getTranslations: _getTranslations,
            isDroppointSearch: _isDroppointSearch,
            getDistance: getDistance,
            getMyLocation: getMyLocation,
            syncTranslateGoogleToBaiduCoords: syncTranslateGoogleToBaiduCoords,
            existsOpeningHours: existsOpeningHours
        };

        return service;

        /**
         * @ngdoc method
         * @name _setStep
         * @methodOf  common.store.service:ItxStoreLocatorSvc
         */
        function _setStep(step) {
            _this.step = step;
        }
        /**
         * @ngdoc method
         * @name _getStep
         * @methodOf  common.store.service:ItxStoreLocatorSvc
         */
        function _getStep() {
            return _this.step;
        }
        /**
         * @ngdoc method
         * @name _setSearchType
         * @methodOf  common.store.service:ItxStoreLocatorSvc
         * @description
         * Set type of search.
         * @param {string} searchType  Search type
         */
        function _setSearchType(searchType) {
            _this.searchType = searchType;
        }
        /**
         * @ngdoc method
         * @name getTimeTable
         * @see https://axinjiraneg1.central.inditex.grp/browse/MDECOMM-5695
         * @methodOf  common.store.service:ItxStoreLocatorSvc
         * @description
         * Returns the opening hours for given store.
         */
        function _getTimeTable(store) {

            var timeTable = [],
                timeTableWeekend = [];
            var genericHoursExists = store.genericOpeningHours && store.genericOpeningHours !== '';

            if (_isDroppointSearch() && store) {

                if (store.openingHours) {
                    if (store.openingHours['mondayTime'] && store.openingHours['mondayTime'] > 1) {
                        timeTable.push(ItxTranslateSvc.translateCms('legacy.Messages_LUNES') + ': ' + store.openingHours['mondayTime']);
                    }
                    if (store.openingHours['tuesdayTime'] && store.openingHours['tuesdayTime'].length > 1 ) {
                        timeTable.push(ItxTranslateSvc.translateCms('legacy.Messages_MARTES') + ': ' + store.openingHours['tuesdayTime']);
                    }
                    if (store.openingHours['wednesdayTime'] && store.openingHours['wednesdayTime'].length > 1 ) {
                        timeTable.push(ItxTranslateSvc.translateCms('legacy.Messages_MIERCO') + ': ' + store.openingHours['wednesdayTime']);
                    }
                    if (store.openingHours['thursdayTime'] && store.openingHours['thursdayTime'].length > 1) {
                        timeTable.push(ItxTranslateSvc.translateCms('legacy.Messages_JUEVES') + ': ' + store.openingHours['thursdayTime']);
                    }
                    if (store.openingHours['fridayTime'] && store.openingHours['fridayTime'].length > 1) {
                        timeTable.push(ItxTranslateSvc.translateCms('legacy.Messages_VIERNES') + ': ' + store.openingHours['fridayTime']);
                    }
                    if (store.openingHours['saturdayTime'] && store.openingHours['saturdayTime'].length > 1 ) {
                        timeTable.push(ItxTranslateSvc.translateCms('legacy.Messages_SABADO') + ': ' + store.openingHours['saturdayTime']);
                    }
                    if (store.openingHours['sundayTime'] && store.openingHours['sundayTime'].length > 1 ) {
                        timeTable.push(ItxTranslateSvc.translateCms('legacy.Messages_DOMINGO') + ': ' + store.openingHours['sundayTime']);
                    }

                } else if (genericHoursExists) {
                    timeTable[0] = store.genericOpeningHours;
                }
            }

            return {
                'timeTable': timeTable,
                'timeTableWeekend': (!genericHoursExists && store.openingHours && store.openingHours['saturdayTime'] !== '') ? timeTableWeekend : null
            };
        }
        /**
         * @ngdoc method
         * @name existsOpeningHours
         * @see https://axinjiraneg1.central.inditex.grp/browse/MDECOMM-5695
         * @methodOf  common.store.service:ItxStoreLocatorSvc
         * @description
         * Returns true if any of the store days has a time value.
         * @returns {boolean} exists at least one day with information
         * 
         * @example
         * Example of opening hours object
         * ```
         * openingHours:{
         *  mondayTime: "09:00:00-18:00:00",
         *  tuesdayTime: "09:30:00-18:00:00",
         *  wednesdayTime: "09:00:00-18:00:00",
         *  thursdayTime: "09:00:00-18:00:00",
         *  fridayTime: "09:00:00-18:00:00",
         *  saturdayTime: "09:00:00-12:30:00"
         *  sundayTime: null
         * }
         * ```
         */
        function existsOpeningHours (store){
            var days = ['mondayTime','tuesdayTime','wednesdayTime','thursdayTime','fridayTime','saturdayTime','sundayTime'];
            var exists = false;
            if(!store.openingHours){
                return false;
            }

            angular.forEach(days, function(key){
                if(store.openingHours[key] && store.openingHours[key].length>1){
                    exists= true;
                }
            });

            return exists;
        }

        /**
         * @ngdoc method
         * @name _isDroppointSearch
         * @see https://axinjiraneg1.central.inditex.grp/browse/MDECOMM-5695
         * @methodOf  common.store.service:ItxStoreLocatorSvc
         * @description
         * Returns if it is a droppoint search checking joyr.constants DROPBOX, DROPPOINT and ITXDROPPOINT.
         * @returns {boolean} is Drop Point Search 
         */
        function _isDroppointSearch() {
            return (_this.searchType === joyr.constants.shippingMethods.DROPBOX ||
                _this.searchType === joyr.constants.shippingMethods.DROPPOINT ||
                _this.searchType === joyr.constants.shippingMethods.ITXDROPPOINT);
        }
        /**
         * @ngdoc method
         * @name _getTranslations
         * @methodOf  common.store.service:ItxStoreLocatorSvc
         * @description
         * Return Translations
         * @returns {object} text- Text translations.
         */
        function _getTranslations(searchType) {
            if(searchType){
                _this.searchType =searchType;
            } 
            var text = {
                title: _isDroppointSearch() ? ItxTranslateSvc.translateCms('legacy.customMap_droppointFinder') : ItxTranslateSvc.translateCms('legacy.customMap_storeFinder'),
                closerStores: _isDroppointSearch() ? ItxTranslateSvc.translateCms('legacy.customMap_closerDroppoints') : ItxTranslateSvc.translateCms('legacy.customMap_closerStores'),
                result: ItxTranslateSvc.translateCms('legacy.ItxDropPointLocatorView.result.dropPoint.location') + ' : ',
                stores: ItxTranslateSvc.translateCms('legacy.ItxMyAccountMenuPage.stores'),
                noResults: ItxTranslateSvc.translateCms('legacy.ItxStoreLocatorView.noResults'),
                selectStore: ItxTranslateSvc.translateCms('legacy.customMap_selectStore'),
                highVolume: ItxTranslateSvc.translateCms('legacy.ordershipping.highVolume'),
                showMore: ItxTranslateSvc.translateCms('legacy.results.showMore'),
                selectDroppoint: ItxTranslateSvc.translateCms('legacy.customMap_selectDroppoint'),
                openingHours: ItxTranslateSvc.translateCms('legacy.ItxStoreLocatorView.openingHours'),
                call: ItxTranslateSvc.translateCms('legacy.ItxMyAccountView.call'),
                selectShop: ItxTranslateSvc.translateCms('legacy.Messages_selectShop'),
                searchInputPlaceholder: ItxTranslateSvc.translateCms('legacy.customMap_info')
            };

            if (_isDroppointSearch()) {
                var value = inditex.iXconfVars['DROP_POINT_SERVICE_PROVIDER'];
                if (inditex.iCountryCode !== 'ES' && value !== 'CHRONOPOST') {
                    text.searchInputPlaceholder = ItxTranslateSvc.translateCms('legacy.customMap_info_ZipCode');
                }
            }
            return text;
        }


        /**
         * Returns distance from the destinations to the origin
         * @param {Object} origin - origin object
         * @param {Number} origin[].latitude - latitude
         * @param {Number} origin[].longitude - longitude
         * @param {array} destinations - stores to calculate distante from origin
         * @returns {joyr.Promise}
         */
        function getDistance(origin, destinations) {
            var promise;
            if (inditex.iStoreJSON.countryCode === 'CN' && inditex.iBaiduMapsKey) {
                promise = getBaiduDistance(origin, destinations);
            } else {
                promise = getGoogleDistance(origin, destinations);
            }
            return promise;
        }

        /**
         * Translate google to baidu cords
         * @param {Number} latitude - latitude
         * @param {Number} longitude - longitude
         * @returns {joyr.Promise}
         */
        function syncTranslateGoogleToBaiduCoords(longitude, latitude) { //jshint  ignore:line
            return syncTranslateGoogleToBaiduCoordsInner(longitude, latitude);
        }



        function syncTranslateGoogleToBaiduCoordsInner(longitude, latitude) {
            var url = 'https://api.map.baidu.com/ag/coord/convert?from=2&to=4&x=' + longitude + '&y=' + latitude;

            return new joyr.Promise(function(resolve) {
                joyr.rest.xRestGetJSONP(url).done(function(data) {
                    var point = new BMap.Point(data.x, data.y); //jshint  ignore:line
                    resolve(point);
                });
            });
        }

        function getBaiduDistanceInner(chunk, origin) {
            var url = 'https://api.map.baidu.com/direction/v1/routematrix?output=json&origins={origins}&destinations={destinations}&ak=' + inditex.iBaiduMapsKey,
                origins = origin[0].latitude + ',' + origin[0].longitude,
                prom = [],
                destinations = '';

            return new joyr.Promise(function(resolve) {
                for (var i = 0; i < chunk.length; i++) {
                    prom.push(syncTranslateGoogleToBaiduCoordsInner(chunk[i].longitude, chunk[i].latitude));
                }
                joyr.Promise.all(prom)
                    .done(function(results) {
                        for (var i = 0; i < results.length; i++) {
                            destinations += results[i].lat + ',' + results[i].lng + (i === results.length - 1 ? '' : '|');
                        }
                        url = url.replace('{origins}', origins).replace('{destinations}', destinations);
                        joyr.rest.xRestGetJSONP(url).done(function(data) {
                            resolve(data.result.elements);
                        });
                    });

            });

        }

        function getBaiduDistance(origin, destination) {

            return new joyr.Promise(function(resolve, reject) {
                var promises = [];
                var aDistances = [
                    []
                ];
                var distancesResult = [];
                //Baidu no resuelve una matriz de distancias de mas de 5 elementos
                var BAIDU_MAX_SIZE = 5;
                var destinations = destination.slice();
                var chunk = destinations.splice(0, BAIDU_MAX_SIZE);
                while (chunk.length > 0) {
                    promises.push(getBaiduDistanceInner(chunk, origin));
                    chunk = destinations.splice(0, BAIDU_MAX_SIZE);
                }

                joyr.Promise.all(promises).done(function(results) {
                    for (var i = 0; i < results.length; i++) {
                        distancesResult = distancesResult.concat(results[i]);
                    }
                    try {
                        distancesResult.sort(function(a, b) {
                            if (a.distance.value < b.distance.value) {
                                return -1;
                            }
                            if (a.distance.value > b.distance.value) {
                                return 1;
                            }
                            return 0;
                        });
                    } catch (e) {
                        reject(e);
                    }
                    for (i = 0; i < distancesResult.length; i++) {
                        if (distancesResult[i].distance) {
                            aDistances[0].push(distancesResult[i].distance.text);
                        }
                    }
                    resolve(aDistances);
                });
            });
        }

        function getGoogleDistanceInner(origin, destination) {
            return new joyr.Promise(function(resolve) {
                var gOrigins = [];
                var gDestinations = [];

                for (var i = 0; i < origin.length; i++) {
                    gOrigins.push(new google.maps.LatLng(origin[i].latitude, origin[i].longitude));
                }
                for (i = 0; i < destination.length; i++) {
                    gDestinations.push(new google.maps.LatLng(destination[i].latitude, destination[i].longitude));
                }
                var service = new google.maps.DistanceMatrixService();

                //FOR USA AND GREAT BRITAIN we select Imperial unit
                var unitSystem = google.maps.UnitSystem.METRIC;
                if (ItxConfigurationSvc.showInMiles()) {

                    unitSystem = google.maps.UnitSystem.IMPERIAL;
                }

                service.getDistanceMatrix({
                    origins: gOrigins,
                    destinations: gDestinations,
                    travelMode: google.maps.TravelMode.DRIVING,
                    avoidHighways: false,
                    unitSystem: unitSystem,
                    avoidTolls: false
                }, function(response, status) {
                    var aDistances = [];
                    if (status === google.maps.DistanceMatrixStatus.OK) {
                        var origins = response.originAddresses;
                        //var destinations = response.destinationAddresses;

                        for (var i = 0; i < origins.length; i++) {
                            var aTmpDistances = [];

                            var results = response.rows[i].elements;
                            for (var j = 0; j < results.length; j++) {
                                var element = results[j];
                                var distance = element.distance ? element.distance.text : '-';
                                aTmpDistances.push(distance);
                            }

                            aDistances.push(aTmpDistances);
                        }
                    }
                    if (destination.length && (!aDistances[0] || (destination.length !== aDistances[0].length))) {
                        for (var i = 0; i < origin.length; i++) { //jshint  ignore:line
                            var aTmpDistances = []; //jshint  ignore:line

                            for (var i = 0; i < destination.length; i++) { //jshint  ignore:line
                                aTmpDistances.push('-');
                            }

                            aDistances.push(aTmpDistances);
                        }
                    }
                    resolve(aDistances);
                });
            });
        }

        function getGoogleDistance(origin, destination) {
            // Google no resuelve una matriz de distancias de más de 25 elementos
            var GOOGLE_MAX_SIZE = 25;
            return new joyr.Promise(function(resolve) {
                var promises = [];
                var aDistances = null;
                var destinations = destination.slice();
                var chunk = destinations.splice(0, GOOGLE_MAX_SIZE);
                while (chunk.length > 0) {
                    promises.push(getGoogleDistanceInner(origin, chunk));
                    chunk = destinations.splice(0, GOOGLE_MAX_SIZE);
                }
                joyr.Promise.all(promises).done(function(results) {
                    for (var i = 0; i < results.length; i++) {
                        var result = results[i];
                        if (!aDistances) {
                            aDistances = result;
                            continue;
                        }
                        for (var j = 0; j < result.length; j++) {
                            aDistances[j] = aDistances[j].concat(result[j]);
                        }
                    }
                    resolve(aDistances);
                });
            });

        }

        function getMyLocation() {
            var deferred = $q.defer();           

            var isFirefox = typeof InstallTrigger !== 'undefined';

            if (isFirefox && navigator.permissions) {
                navigator.permissions.query({
                    name: 'geolocation'
                }).then(function(result) {
                    if (result.state === 'prompt') {
                        getMyLocationPriv().then(function(myLocation){
                            deferred.resolve(myLocation);
                        });
                    }
                    result.onchange = function() {
                        if (result.state === 'prompt') {
                            getMyLocationPriv().then(function(myLocation){
                                deferred.resolve(myLocation);
                            });
                        }
                    };
                });
            }
            else{
                getMyLocationPriv().then(function(myLocation){
                    deferred.resolve(myLocation);
                });
            }

            return deferred.promise;
        }

        function getMyLocationPriv() {
        
            var deferred = $q.defer();                   
                
            var myLocation = {longitude:0,latitude:0};

            navigator.geolocation.getCurrentPosition(
                function(position) {
                
                    myLocation.longitude = position.coords.longitude;
                    myLocation.latitude = position.coords.latitude;
                    deferred.resolve(myLocation);
                },
                function() {
                    joyr.rest.xGetGeolocation()
                        .done(function(data) {
                            myLocation.longitude = data.long;
                            myLocation.latitude = data.lat;
                            deferred.resolve(myLocation);
                            
                        });
            });
            return deferred.promise;
        }
    }


})();